import { create } from 'zustand';
import { UserObject } from '../util/Types/User';

type ObjectStore = {
    objects: Record<string, UserObject[]>;
    setObjects: (objects: UserObject[] | undefined, spaceId: string) => void;
    objectUpdate: UserObject;
    resetObjectUpdate: () => void;
    setObjectUpdate: (objectUpdate: UserObject) => void;
    updateObject: (objectId: string, updatedObject: UserObject, spaceId: string) => void;
    addObject: (object: UserObject, spaceId: string) => void;
    removeObject: (objectId: string, spaceId: string) => void;
    getObjectsBySpaceId: (spaceId: string) => UserObject[];
};

const defaultObject: UserObject = {
    name: '',
    isCreating: true,
    localObject: false,
    flowId: '',
    id: '',
    text: [
        {
            text: '',
            id: Math.random().toString(36).substring(2, 9),
        },
    ],
};

const setDefaultObject = () => {
    return ({ ...defaultObject, id: Math.random().toString(36).substring(2, 9) });
};

export const useObjectStore = create<ObjectStore>((set, get) => ({
    objects: {},
    objectUpdate: setDefaultObject(),
    getObjectsBySpaceId: (spaceId) => {
        return get().objects[spaceId] || [];
    },
    resetObjectUpdate: () => set({ objectUpdate: setDefaultObject() }),
    setObjectUpdate: (objectUpdate) => set({ objectUpdate }),
    setObjects: (objects, spaceId) => {
        set((state) => ({
            objects: {
                ...state.objects,
                [spaceId]: objects || []
            }
        }))
    },
    updateObject: (objectId, updatedObject, spaceId) =>
        set((state) => ({
            objects: {
                ...state.objects,
                [spaceId]: state.objects?.[spaceId]?.map((obj) =>
                    obj.id === objectId ? { ...obj, ...updatedObject } : obj
                )
            }
        })),
    addObject: (object, spaceId) =>
        set((state) => ({
            objects: {
                ...state.objects,
                [spaceId]: [...state.objects?.[spaceId] || [], { ...object, isCreating: false }]
            }
        })),
    removeObject: (objectId, spaceId) =>
        set((state) => ({
            objects: {
                ...state.objects,
                [spaceId]: state.objects?.[spaceId]?.filter((obj) => obj.id !== objectId) || []
            }
        })),
})); 